<script>
	import thumb_SdB7Oj1Ayv4 from '$lib/Components/Youtube/images/SdB7Oj1Ayv4.jpg';
	import thumb_lUIRQdgq1HE from '$lib/Components/Youtube/images/lUIRQdgq1HE.jpg';

	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import CustomizeYourInsert from '$lib/PageSections/CustomizeYourInsert/CustomizeYourInsert.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import HowWindowInsertsWork from '$lib/PageSections/HowWindowInsertsWork/HowWindowInsertsWork.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import energyEfficiency from './images/energy-efficiency-window-installment.jpg';
</script>

<Section>
	<h2>Street Noise Disrupting Your Life?</h2>
	<p>
		You can have peace and quiet even when it’s loud outside. Reinforce your
		windows against noise penetration – without having to replace them. Award
		winning Indow window inserts just press inside your window frames to block
		50 to 70% of the noise that's bothering you.*
	</p>
	<Image
		src={energyEfficiency}
		alt="Woman installing an Indow insert inside of a window"
	/>
</Section>
<Section>
	<h2>Indow Creates A Sanctuary From Noise</h2>
	<p>
		We care about creating shelters from sound in homes because we know what
		chronic exposure to noise can lead to: stress, heart disease, poor cognitive
		performance. Providing a solution that works with existing windows puts less
		material in landfills – that's part of <a href="/about-indow"
			>our sustainable mission.</a
		>
	</p>
</Section>
<HowWindowInsertsWork />
<Section>
	<h2>Window Expert Weighs in on Indow Inserts</h2>
	<p>
		Scott Sidler has been working with windows for years. He owns his own
		historic restoration company and runs the national The Craftsman Blog, which
		he calls his “laboratory, classroom, playground”.
	</p>
	<p>
		He jumped at the chance to play with our Acoustic Grade window inserts in
		his shop:
	</p>
	<Youtube
		posterImageSrc={thumb_SdB7Oj1Ayv4}
		src="https://www.youtube.com/embed/SdB7Oj1Ayv4"
		title="How To Soundproof Windows"
	/>
	<p>
		Blogger and DIY expert Mandi Gubler of Vintage Revivals could hear traffic
		noise coming through the century-old mercantile she's turning into a home
		and office in a historic building renovation. It was way. too. loud. One of
		the building blocks of a comfortable home is quiet – so you can think. And
		no drafts – so you don't shiver. And good design for everything inside it.
		Fortunately, Indow window inserts delivered all three for Mandi.
	</p>
	<Youtube
		posterImageSrc={thumb_lUIRQdgq1HE}
		src="https://www.youtube.com/embed/lUIRQdgq1HE"
		title="Saving Our Historic Windows (and Making Them 100x Better with Indow)"
	/>
</Section>
<Reviews />
<Section>
	<p>
		Indow window inserts are the soundproofing solution that can finally put an
		end to your noise issues. Enjoy peace, quiet, and start saving an average of
		20% on your energy bills. Fill out the form below for a free estimate.
	</p>
	<p class="text-xs">
		*Note, overall noise reduction performance depends on how much noise is
		coming through walls, ceilings, floor, and doors. The window noise reduction
		will be less when Indow inserts are placed over double-pane windows. We do
		not recommend Indow inserts for reducing noise coming through laminated
		glass windows, triple pane windows, or hurricane windows.
	</p>
</Section>
<Section backgroundColor="grey">
	<p class="!text-indow-blue text-2xl italic">
		Indow is fully operational making window inserts that bring comfort and
		quiet to your home and work spaces. Our production team is using Clean
		Manufacturing principles we have developed to keep them safe. No one needs
		to enter your home to measure or install our inserts. We ship a self-service
		measure kit (sanitized between each use) and deliver the inserts to your
		door. Just pull the insert from the box and they are ready for installation.
		We look forward to serving you.
	</p>
</Section>
<Awards backgroundColor="white" />
<GetAFreeEstimate backgroundColor="grey" />
<CustomizeYourInsert />
